<div class="field-display">
  <span class="field-value" [style.backgroundColor]="backgroundColor">{{displayValue}}</span>
  <button type="button" mat-icon-button
      class="field-copy-button"
      matTooltip="Copy"
      [cdkCopyToClipboard]="displayValue"
      (cdkCopyToClipboardCopied)="onCopyToClipboard.emit('Field value was copied to clipboard.')"
      (click)="$event.stopPropagation()">
      <mat-icon>content_copy</mat-icon>
  </button>
</div>
